import axios from "axios";

export async function getUsersByCompany(companyId: string, token:string): Promise<any> {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/usuarios/empresa/${companyId}`, 
        {
          headers: {
              Authorization: 'Bearer ' + token
          }
        });
  
      return response.data; // Supondo que os usuarios sejam retornados pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
  }